@if (busy) {
  <div class="overlay">
    <div class="center">
      <mat-spinner>
      </mat-spinner>
    </div>
  </div>
}
<div class="dialog-content flex-col w-100 justify-stretch items-stretch">
  <h2 mat-dialog-title>{{title}}</h2>
  <mat-dialog-content>
    @if(!userApprovalPendingOrApproved) { 
      <div [innerHTML]="message"></div>
    }
    @else if (buyerUploadsRequired){
      <div class="flex-col w-100">
        <b class="w-100 my-3">You need to upload the following document types for us to be able to approve you: </b>
        <mat-accordion>
          @for(item of property.auction!.buyerUploadsRequired; track item.documentTypeId!){
            @let vdArray = existingVaultDocumentForDocumentType(item.documentTypeId!);
            <mat-expansion-panel hideToggle="true">
              <mat-expansion-panel-header>
                <mat-panel-description class="space-between">
                  <span class="flex-row items-center">
                    @if(vdArray.length>0){ <mat-icon class="green-color">check</mat-icon>}
                    @else{ <mat-icon class="red-color">priority_high</mat-icon> }
                    {{item.documentTypeName}}  ({{vdArray.length}} uploaded)
                  </span>
                  <button mat-button color="primary" (click)="onUploadDocumentClick(item)">Upload Document</button>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                @if (vdArray.length>0){<app-documents-table [vaultDocuments]="existingVaultDocumentForDocumentType(item.documentTypeId!)" [readOnly]="true"></app-documents-table>}
                @if (!hasFileSelected(item.documentTypeId!)){
                  <div class="w-100 flex-row justify-end">
                    <button type="button" mat-raised-button (click)="fileInput.click()">Select File</button>
                    <input #fileInput hidden type="file" accept=".pdf,.jpg,.png" (change)="fileBrowseHandler($event, item.documentTypeId!)"/>
                  </div>
                }
                @else {
                  <span class="mr-3">{{selectedFile(item.documentTypeId!)?.name}}</span>
                  <button type="button" mat-raised-button (click)="uploadSelectedFile(item.documentTypeId!)">Upload File</button>
                }
              </ng-template>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="flex-row space-between items-center w-100 my-3">
      @if(!userApprovalPendingOrApproved) {<button mat-flat-button class="w-49" color="primary" (click)="onConfirmClick()" tabindex="1" [disabled]="!canConfirm">{{confirmButtonText}}</button>}
      <button mat-flat-button [class]="userApprovalPendingOrApproved?'w-100':'w-49'" color="primary" (click)="onCancelClick()" >{{cancelButtonText}}</button>
    </div>
  </mat-dialog-actions>
</div>

